import React from "react";
import ReactDOM from "react-dom/client";
import { unstable_HistoryRouter as HistoryRouter } from "react-router-dom";
import { appHistory } from "./services/navigation";
import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";

import reportWebVitals from "./reportWebVitals";
import { setUpStore } from "./redux/store";

import "react-toastify/dist/ReactToastify.css";
import "./index.css";
import { ThemeProvider, createTheme } from "@mui/material";
import AppRoutes from "./routes/AppRoutes";
import { SideBarItemsProvider } from "./context/sidebarContext";
import { DeviceSocketProvider, SocketProvider } from "./context/socketContext";
import { TourProvider } from "./context/tourContext";
import { PlantProvider } from "./context/plantContext";
import { BrandingProvider } from "./context/brandingContext";

const appFont = createTheme({
	typography: {
		fontFamily: ["Nunito", "serif"].join(","),
	},
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
<React.StrictMode>
	<Provider store={setUpStore()}>
		<HistoryRouter history={appHistory}>
			<ThemeProvider theme={appFont}>
				<PlantProvider>
					<BrandingProvider>
						<TourProvider>
							<SocketProvider>
								<DeviceSocketProvider>
									<AppRoutes />
									<ToastContainer position="bottom-center" />
								</DeviceSocketProvider>
							</SocketProvider>
						</TourProvider>
					</BrandingProvider>
				</PlantProvider>
			</ThemeProvider>
		</HistoryRouter>
	</Provider>
</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
